import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginStateService } from '../services/login-state.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private loginStateService: LoginStateService,
    private router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.loginStateService.isLoggedIn;
  }
}
